import * as _ from 'lodash'
let resolve = () => {
  let data = {}
  let builder = {
    set: (key, value) => {
      if (!_.isUndefined(value)) {
        data[key] = value
      }
      return builder
    },
    build: () => {
      return data
    }
  }
  return builder
}

export default {
  resolve
}
